import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js';
import React from 'react'
import BookingStatusComponent from '@/Components/Booking/BookingStatusComponent';

export const BookingStatusFragment = () => {
    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

    return (
        <Elements stripe={stripePromise}>
            <BookingStatusComponent />
        </Elements>
    )
}
